import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const More: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="12" r="2.1" fill="currentColor" />
    <circle cx="12" cy="12" r="2.1" fill="currentColor" />
    <circle cx="19" cy="12" r="2.1" fill="currentColor" />
  </svg>
);
